import { DropboxFileItem } from '@common/types/dropbox';
import { MediaAssetsContext } from '@mediaAssets/contexts';
import { MediaAssetsGallery, MediaAssetsGridView, MediaAssetsListView } from '@mediaAssets/routes';
import { useEffect, useState } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

export const MediaAssets = () => {
    const [selectedMediaAsset, setSelectedMediaAsset] = useState<DropboxFileItem | null>(null);
    const [visibleMediaAssets, setVisibleMediaAssets] = useState<DropboxFileItem[]>([]);
    const [galleryOpen, setGalleryOpen] = useState(false);

    const [params] = useSearchParams();
    const { pathname } = useLocation();

    const view = params.get('view') === 'list' ? 'list' : 'grid';

    useEffect(() => {
        setSelectedMediaAsset(null);
        setGalleryOpen(false);
    }, [pathname]);

    const handleCloseGallery = () => {
        setGalleryOpen(false);
        setSelectedMediaAsset(null);
    };

    return (
        <MediaAssetsContext.Provider
            value={{
                selectedMediaAsset,
                setSelectedMediaAsset,
                visibleMediaAssets,
                setVisibleMediaAssets,
                galleryOpen,
                setGalleryOpen,
            }}
        >
            <div className="p-[26px] h-full">
                {view === 'grid' ? <MediaAssetsGridView /> : <MediaAssetsListView />}
                <MediaAssetsGallery open={galleryOpen} onClose={handleCloseGallery} />
            </div>
        </MediaAssetsContext.Provider>
    );
};
